import React, { useEffect } from "react";
import { useLocation } from "@reach/router";
import classNames from "classnames";

import Header from "./Header";
import StockBar from "./StockBar";
import Footer from "./Footer";
import CookieConsentBanner from "./CookieConsentBanner";
import { ReactLenis, useLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import handleIframeScroll from "../utils/handleIframeScroll";

const Layout = ({ children, className }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useLenis(({ velocity }) => {
    handleIframeScroll(velocity);
  });

  return (
    <ReactLenis root options={{ duration: 1.7 }}>
      <div className="flex flex-col min-h-screen">
        <Header />
        <StockBar />
        <div
          className={classNames(
            "relative w-full lg:pl-[var(--stock-bar-width)]",
            "pt-50px md:pt-90px mb-auto",
            className
          )}
        >
          {children}
        </div>
        <Footer />
        <CookieConsentBanner />
      </div>
    </ReactLenis>
  );
};

export default Layout;
